import { testimonials } from '@/mocks/testimonials';

export default function Testimonials() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs font-semibold text-foreground-500 font-label tracking-wide">Testimonials</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
            Trusted by Thousands of Fashion Shoppers
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            See what real users say about the CSSBuy spreadsheet directory
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.map((t, index) => (
            <div
              key={t.name}
              className="bg-white rounded-xl p-6 border border-background-200/70 hover:border-accent-200/50 transition-all duration-300"
              style={{ animationDelay: `${index * 80}ms` }}
            >
              <div className="flex items-center gap-1 mb-3">
                {[...Array(t.rating)].map((_, i) => (
                  <span key={i} className="w-4 h-4 flex items-center justify-center text-accent-500">
                    <i className="ri-star-fill text-sm"></i>
                  </span>
                ))}
              </div>

              <h4 className="text-sm font-semibold text-foreground-900 mb-2">{t.title}</h4>

              <p className="text-xs text-foreground-500 leading-relaxed mb-4 line-clamp-4">
                {t.content}
              </p>

              <div className="flex items-center gap-3 pt-3 border-t border-background-100">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-9 h-9 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <p className="text-xs font-semibold text-foreground-800">{t.name}</p>
                  <p className="text-[11px] text-foreground-400">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}